/**
 * Environment Banner Component
 * Shows a visual indicator when NOT in production mode
 * This helps prevent confusion between test and live environments
 */

import { environment } from '../services/firebase';

export function EnvironmentBanner() {
  // Only show in non-production environments
  if (environment.isProduction) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-orange-500 text-white text-center py-1 text-xs font-bold tracking-wide shadow-md">
      ⚠️ {environment.label} — PayPal Sandbox Mode (No Real Charges)
    </div>
  );
}
